<template>
  <div class="grid-container pb-5">
    <div class="section-header section-header--xl section-header--dividing">
      <h1 class="heading heading--xl" qaid="techtext-header" v-html="getBaseProperty('techText')"></h1>
    </div>

    <section>
      <div class="section-header section-header--md mb-3">
        <h3 class="heading" qaid="tech-select-product-header" v-html="getBaseProperty('productSelectionText')"></h3>
      </div>
    </section>

    <section>
      <div class="grid-x grid-margin-x grid-margin-y">
        <div class="cell medium-4">
          <fieldset qaid="techtext-fieldset" class="form-fieldset max-w-sm">
            <label for="select-year" class="form-label" v-html="getBaseProperty('yearLabelText')"></label>
            <div class="select mb-2">
              <select
                id="select-year"
                v-model="selectedYear"
                qaid="tech-year-dropdown"
                class="form-control"
                @change="retrieveModelOptions"
              >
                <option v-for="(year, index) in yearData" :key="index" :disabled="index === 0" :value="year">{{
                  year
                }}</option>
              </select>
            </div>

            <label for="select-model" class="form-label" v-html="getBaseProperty('modelLabelText')"></label>
            <tech-model-tippy-container
              :options-list="modelData"
              :please-select-model="getBaseProperty('pleaseSelectModel')"
              :popup-close-tooltip="bp('closePopup')"
              @selection-made="retrieveColorOptions"
            ></tech-model-tippy-container>

            <label for="select-size" class="form-label" v-html="getBaseProperty('colorLabelText')"></label>
            <div class="select mb-2">
              <select
                id="select-size"
                v-model="selectedColor"
                qaid="tech-color-dropdown"
                class="form-control"
                @change="retrieveSizeOptions"
              >
                <option v-for="(color, index) in colorData" :key="index" :disabled="index === 0" :value="index">{{
                  color.name
                }}</option>
              </select>
            </div>

            <label for="select-size" class="form-label" v-html="getBaseProperty('sizeLabelText')"></label>
            <div class="select mb-2">
              <select
                id="select-size"
                v-model="selectedSize"
                qaid="tech-size-dropdown"
                class="form-control"
                @change="setSkuAndEnableSubmit"
              >
                <option v-for="(item, index) in sizeData" :key="index" :disabled="index === 0" :value="item.id">{{
                  item.size
                }}</option>
              </select>
            </div>
          </fieldset>
          <div class="buttons">
            <trek-button
              primary
              :disabled="readyToSubmit === false"
              qaid="tech-view-product-btn"
              @click="setSkuVuexAndRelocate"
            >
              <span v-html="getBaseProperty('viewProductText')"></span>
            </trek-button>
          </div>
        </div>
        <div class="cell sm:hidden md:inline-block medium-8" qaid="tech-static-image">
          <img :src="staticImageUrl" />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from 'axios';
import {mapMutations, mapState} from 'vuex';
import TrekButton from '@/components/TrekButton';

export default {
  components: {TrekButton},
  props: {
    staticImageUrl: {
      type: String,
      default: '',
    },
    baseProperties: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      loading: true,
      yearData: [this.getBaseProperty('pleaseSelectText')],
      modelData: [],
      colorData: [],
      sizeData: [],
      selectedYear: this.getBaseProperty('pleaseSelectText'),
      selectedModel: '',
      selectedSize: '',
      selectedColor: '0',
      readyToSubmit: false,
      selectedSku: '0',
    };
  },

  computed: {
    ...mapState('backend', ['encodedContextPath']),
  },

  created() {
    this.resetModelData();
    this.retrieveYearOptions();
  },

  methods: {
    resetSizeData() {
      this.setFormReadyStatus(false);
      this.sizeData = [{size: this.getBaseProperty('pleaseSelectText'), id: ''}];
      this.selectedSize = '';
      this.selectedSku = '0';
    },

    resetColorData() {
      this.colorData = [{name: this.getBaseProperty('pleaseSelectText'), id: '0'}];
      this.selectedColor = '0';
      this.resetSizeData();
    },

    resetModelData() {
      this.modelData = [{name: this.getBaseProperty('pleaseSelectText'), id: '-1'}];
      this.selectedModel = '';
      this.resetColorData();
    },

    setFormReadyStatus(val) {
      this.readyToSubmit = val;
    },

    retrieveYearOptions() {
      this.loading = true;
      axios
        .get('/technical-specification/selector/bikes')
        .then(({data}) => {
          this.yearData = [this.getBaseProperty('pleaseSelectText'), ...data.data];
        })
        .catch((error) => console.log(error))
        .finally(() => (this.loading = false));
    },

    retrieveModelOptions() {
      this.loading = true;
      this.resetModelData();
      axios
        .get(`/technical-specification/selector/bikes/${this.selectedYear}`)
        .then(({data}) => {
          this.modelData = data.data;
        })
        .catch((error) => console.log(error))
        .finally(() => (this.loading = false));
    },

    retrieveColorOptions(model) {
      this.loading = true;
      this.resetColorData();
      this.selectedModel = model.id;
      axios
        .get('/technical-specification/selector/matrix/' + this.selectedModel)
        .then(({data}) => {
          this.colorData = [{name: this.getBaseProperty('pleaseSelectText'), id: '0'}, ...data.data];
        })
        .catch((error) => console.log(error))
        .finally(() => (this.loading = false));
    },

    retrieveSizeOptions() {
      // No need for an Ajax call here as size data is already included with each color
      this.resetSizeData();
      this.sizeData = [
        {size: this.getBaseProperty('pleaseSelectText'), id: ''},
        ...this.colorData[this.selectedColor].sizes,
      ];
    },

    setSkuAndEnableSubmit() {
      this.setFormReadyStatus(true);
      this.selectedSku = this.selectedSize;
    },

    setSkuVuexAndRelocate() {
      this.setBikeTechSKU(this.selectedSku);
      window.location = `${this.encodedContextPath}/tech-details/${this.selectedModel}`;
    },

    ...mapMutations('storage', ['setBikeTechSKU']),
  },
};
</script>
